daffy.socketio = {
	open_tasks: {},
	open_docs: [],
	emit_queue: [],
	init: function(port = 3000) {
		if (!window.io) {
			return;
		}

		if (daffy.boot.disable_async) {
			return;
		}

		if (daffy.socketio.socket) {
			return;
		}

		//Enable secure option when using HTTPS
		if (window.location.protocol == "https:") {
			daffy.socketio.socket = io.connect(daffy.socketio.get_host(port), {secure: true});
		}
		else if (window.location.protocol == "http:") {
			daffy.socketio.socket = io.connect(daffy.socketio.get_host(port));
		}
		else if (window.location.protocol == "file:") {
			daffy.socketio.socket = io.connect(window.localStorage.server);
		}

		if (!daffy.socketio.socket) {
			console.log("Unable to connect to " + daffy.socketio.get_host(port));
			return;
		}

		daffy.socketio.socket.on('msgprint', function(message) {
			daffy.msgprint(message);
		});

		daffy.socketio.socket.on('eval_js', function(message) {
			eval(message);
		});

		daffy.socketio.socket.on('progress', function(data) {
			if(data.progress) {
				data.percent = flt(data.progress[0]) / data.progress[1] * 100;
			}
			if(data.percent) {
				if(data.percent==100) {
					daffy.hide_progress();
				} else {
					daffy.show_progress(data.title || __("Progress"), data.percent, 100, data.description);
				}
			}
		});

		daffy.socketio.setup_listeners();
		daffy.socketio.setup_reconnect();

		$(document).on('form-load form-rename', function(e, frm) {
			if (frm.is_new()) {
				return;
			}

			for (var i=0, l=daffy.socketio.open_docs.length; i<l; i++) {
				var d = daffy.socketio.open_docs[i];
				if (frm.doctype==d.doctype && frm.docname==d.name) {
					// already subscribed
					return false;
				}
			}

			daffy.socketio.doc_subscribe(frm.doctype, frm.docname);
		});

		$(document).on("form-refresh", function(e, frm) {
			if (frm.is_new()) {
				return;
			}

			daffy.socketio.doc_open(frm.doctype, frm.docname);
		});

		$(document).on('form-unload', function(e, frm) {
			if (frm.is_new()) {
				return;
			}

			// daffy.socketio.doc_unsubscribe(frm.doctype, frm.docname);
			daffy.socketio.doc_close(frm.doctype, frm.docname);
		});

		window.onbeforeunload = function() {
			if (!cur_frm || cur_frm.is_new()) {
				return;
			}

			// if tab/window is closed, notify other users
			if (cur_frm.doc) {
				daffy.socketio.doc_close(cur_frm.doctype, cur_frm.docname);
			}
		}
	},
	get_host: function(port = 3000) {
		var host = window.location.origin;
		if(window.dev_server) {
			var parts = host.split(":");
			port = daffy.boot.socketio_port || port.toString() || '3000';
			if(parts.length > 2) {
				host = parts[0] + ":" + parts[1];
			}
			host = host + ":" + port;
		}
		return host;
	},
	subscribe: function(task_id, opts) {
		// TODO DEPRECATE

		daffy.socketio.socket.emit('task_subscribe', task_id);
		daffy.socketio.socket.emit('progress_subscribe', task_id);

		daffy.socketio.open_tasks[task_id] = opts;
	},
	task_subscribe: function(task_id) {
		daffy.socketio.socket.emit('task_subscribe', task_id);
	},
	task_unsubscribe: function(task_id) {
		daffy.socketio.socket.emit('task_unsubscribe', task_id);
	},
	doc_subscribe: function(doctype, docname) {
		if (daffy.flags.doc_subscribe) {
			console.log('throttled');
			return;
		}

		daffy.flags.doc_subscribe = true;

		// throttle to 1 per sec
		setTimeout(function() { daffy.flags.doc_subscribe = false }, 1000);

		daffy.socketio.socket.emit('doc_subscribe', doctype, docname);
		daffy.socketio.open_docs.push({doctype: doctype, docname: docname});
	},
	doc_unsubscribe: function(doctype, docname) {
		daffy.socketio.socket.emit('doc_unsubscribe', doctype, docname);
		daffy.socketio.open_docs = $.filter(daffy.socketio.open_docs, function(d) {
			if(d.doctype===doctype && d.name===docname) {
				return null;
			} else {
				return d;
			}
		})
	},
	doc_open: function(doctype, docname) {
		// notify that the user has opened this doc, if not already notified
		if(!daffy.socketio.last_doc
			|| (daffy.socketio.last_doc[0]!=doctype && daffy.socketio.last_doc[1]!=docname)) {
			daffy.socketio.socket.emit('doc_open', doctype, docname);
		}
		daffy.socketio.last_doc = [doctype, docname];
	},
	doc_close: function(doctype, docname) {
		// notify that the user has closed this doc
		daffy.socketio.socket.emit('doc_close', doctype, docname);
	},

	setup_listeners: function() {
		daffy.socketio.socket.on('task_status_change', function(data) {
			daffy.socketio.process_response(data, data.status.toLowerCase());
		});
		daffy.socketio.socket.on('task_progress', function(data) {
			daffy.socketio.process_response(data, "progress");
		});
	},
	setup_reconnect: function() {
		// subscribe again to open_tasks
		daffy.socketio.socket.on("connect", function() {
			// wait for 5 seconds before subscribing again
			// because it takes more time to start python server than nodejs server
			// and we use validation requests to python server for subscribing
			setTimeout(function() {
				$.each(daffy.socketio.open_tasks, function(task_id, opts) {
					daffy.socketio.subscribe(task_id, opts);
				});

				// re-connect open docs
				$.each(daffy.socketio.open_docs, function(d) {
					if(locals[d.doctype] && locals[d.doctype][d.name]) {
						daffy.socketio.doc_subscribe(d.doctype, d.name);
					}
				});

				if (cur_frm && cur_frm.doc) {
					daffy.socketio.doc_open(cur_frm.doc.doctype, cur_frm.doc.name);
				}
			}, 5000);
		});
	},
	process_response: function(data, method) {
		if(!data) {
			return;
		}

		// success
		var opts = daffy.socketio.open_tasks[data.task_id];
		if(opts[method]) {
			opts[method](data);
		}

		// "callback" is std daffy term
		if(method==="success") {
			if(opts.callback) opts.callback(data);
		}

		// always
		daffy.request.cleanup(opts, data);
		if(opts.always) {
			opts.always(data);
		}

		// error
		if(data.status_code && data.status_code > 400 && opts.error) {
			opts.error(data);
		}
	}
}

daffy.provide("daffy.realtime");
daffy.realtime.on = function(event, callback) {
	daffy.socketio.socket && daffy.socketio.socket.on(event, callback);
};

daffy.realtime.off = function(event, callback) {
	daffy.socketio.socket && daffy.socketio.socket.off(event, callback);
}

daffy.realtime.publish = function(event, message) {
	if(daffy.socketio.socket) {
		daffy.socketio.socket.emit(event, message);
	}
}

